import React from "react";
import { Button, Text } from "@nextui-org/react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { TbArrowBackUp, TbFileExport } from "react-icons/tb";

const AltAnalyticsHeader = ({ onExport }) => {
  return (
    <motion.div className="header">
      <div style={{ display: "flex", alignItems: "center" }}>
        <Link to="/analytics/alt-entries-ledger" className="headerLink">
          <TbArrowBackUp className="icoAdjust" />
        </Link>
        <Text b>Alt Analytics</Text>
      </div>
      <div className="headerLink headerLinkAddon" style={{ width: 140 }}>
        <Button
          auto
          size="sm"
          color="error"
          icon={<TbFileExport />}
          onClick={onExport}
          title="Export Period"
        />
      </div>
    </motion.div>
  );
};

export default AltAnalyticsHeader;
